const Logger = require("../Logger");

const notifications = [];
let currentTimeout = null;
let currentCount = 0;

const FIVE_SECONDS = 5000;

const addNotification = ( content, duration=FIVE_SECONDS, action=() => {} ) =>
  notifications.push({ content, duration, action });

const clearCurrentTimeout = () => {
  if( currentTimeout ) {
    clearTimeout( currentTimeout );
    currentTimeout = null;
  }
}

const clear = () => {
  notifications.length = 0;
  clearCurrentTimeout();
}

const skipIfCountMatches = ( div, count ) => {
  if( currentCount !== count ) {
    return;
  }

  if( currentTimeout ) {
    clearCurrentTimeout();

    showNextNotification( div );
  }
}

const showNextNotification = div => {
  if (!notifications.length) {
    div.style.display = "none";

    return;
  }

  currentCount++;
  const { content, duration, action } = notifications.shift();

  div.innerHTML = content;

  try {
    const count = currentCount;
    const skip = () => skipIfCountMatches( div, count );

    action( skip );
  } catch (error) {
    Logger.viewerError(
      "E999999999",
      "Error executing notification action",
      { error: error && error.stack }
    );
  }

  currentTimeout = setTimeout( () => {
    currentTimeout = null;
    showNextNotification( div );
  }, duration );
}

const getNotificationsDiv = () => {
  return document.querySelector("#floating-notifications");
}

const areNotificationsAlreadyPlaying = () => {
  const div = getNotificationsDiv();

  return div.style.display === "block";
}

const showNotifications = () => {
  const div = getNotificationsDiv();

  if (!notifications.length || !div || areNotificationsAlreadyPlaying()) {
    return false;
  }

  div.style.display = "block";

  showNextNotification(div);

  return true;
}

module.exports = {
  addNotification,
  showNotifications,
  clear
}
